import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class DocumentTypeRegister {
  @IsNumber()
  @Expose()
  documentTypeId!: number;
  @IsNumber()
  @IsOptional()
  @Expose()
  recordStampId!: number | null;
  @IsString()
  @Expose()
  documentTypeName!: string;
  @IsString()
  @Expose()
  documentGroup!: string;
  @IsString()
  @IsOptional()
  @Expose()
  register!: string | null;
  @IsString()
  @IsOptional()
  @Expose()
  documentCategory!: string | null;
}

export class DocumentTypeRegisterResponse extends GenericTableResponse<DocumentTypeRegister> {
  @Expose()
  @IsArray()
  @Type(() => DocumentTypeRegister)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<DocumentTypeRegister>;
}
